import { SearchError } from './search-error';

export * from './search-error-props';

export default SearchError;
